import {parse as internalParse} from "uiwidgets-datetime";

export function parse(s, dateComponentOrder) {
    return internalParse(s, {dateComponentOrder});
};
